export default __webpack_public_path__ + "static/saasservices-bfe3c74956bfb2cd965b952defaea93b.png";